import { ConfigProvider, Divider } from 'antd';
import * as React from 'react';

interface FCProps {}

const Devider: React.FC<FCProps> = ({}) => {
  return (
    <div>
      <ConfigProvider
        theme={{
          token: {
            marginLG: 30
          }
        }}>
        <Divider />
      </ConfigProvider>
    </div>
  );
};

export default Devider;
